export const UNKNOWN_ERROR = 'Something went wrong.';
